import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Event } from '../../models';
import { JsonPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-event-metadata',
  standalone: true,
  imports: [JsonPipe, RouterLink, FromDictionaryPipe],
  templateUrl: './event-metadata.component.html',
  styleUrl: './event-metadata.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventMetadataComponent {
  event = input.required<Event>();

  metaFields = computed(() => {
    const event = this.event();

    return {
      categories: { dict: 'categorieen', items: event.categories },
      themes: { dict: 'themas', items: event.themes },
      locations: { dict: 'locaties', items: event.locations },
      ageRequirements: { dict: 'leeftijdsgroepen', items: event.ageRequirements },
      discounts: { dict: 'kortingen', items: event.discounts },
      eventType: { dict: 'types', items: event.eventType ? [event.eventType] : [] },
      accessibilityFeatures: { dict: 'toegankelijkheid', items: event.accessibilityFeatures },
    };
  });

  metaFieldKeys = computed(() => Object.keys(this.metaFields()).filter(key => this.metaField(key)?.items?.length || 0 > 0));

  metaField(key: string) {
    const fields = this.metaFields();
    return fields[key as keyof typeof fields];
  }

  filterParam(key: string, id: any) {
    return {
      [key]: id,
    };
  }
}
